var _path, _ellipse, _ellipse2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4073 43.96C10.6361 42.5612 8.47829 38.1166 10.5686 34.3794C11.3091 33.0555 12.3795 32.2357 13.5341 31.7665C12.2816 29.919 10.8646 26.0649 14.6067 22.8985C15.3636 22.2581 16.445 21.9387 17.5363 21.846C18.8032 11.18 29.8883 8.40872 34.3223 9.3589C29.0173 15.5349 33.6097 19.1771 38.5979 22.1859C42.5886 24.5929 40.9469 28.3013 39.6273 29.8546C44.6144 31.9135 46.7108 38.5923 40.7357 42.3765C36.8693 44.8252 26.3252 45.3852 18.4073 43.96Z",
    fill: "#262860"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4267,
    cy: 30.1768,
    rx: 1.98529,
    ry: 2.38235,
    fill: "#0F1030"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.3642,
    cy: 30.1768,
    rx: 1.98529,
    ry: 2.38235,
    fill: "#0F1030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1484 37.0559C25.2042 37.7685 27.9965 38.7662 30.7203 37.0559",
    stroke: "#0F1030",
    strokeWidth: 2.69208,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoo);
export default __webpack_public_path__ + "static/media/poo.8670f49c.svg";
export { ForwardRef as ReactComponent };